import type { components } from '@feedfm/clips-api-client';
import {
  Alert,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useDemoAppContext } from '../../pages/demo/DemoAppContext';
import './Share.css';

const Share = () => {
  const [clipId, setClipId] = useState('');
  const [response, setResponse] = useState<
    components['schemas']['ShareResponse'] | null
  >(null);
  const [error, setError] = useState<string | null>(null);
  const { client, clientId } = useDemoAppContext();

  const timestamp = new Date().toISOString();
  const shareUri = `https://www.feed.fm/`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setResponse(null);

    const response = await client.POST('/share', {
      body: {
        clientId,
        clipId: Number(clipId),
        shareUri: shareUri,
        platform: 'web:demo-app',
      },
    });

    if (response.error) {
      setError(response.error ?? 'An error occurred');
      return;
    }

    if (response.data) {
      setResponse(response.data);
    }
  };

  return (
    <Paper elevation={3} className="share-paper">
      <Typography variant="h5" component="h2" gutterBottom>
        Share (POST /share)
      </Typography>
      <Typography variant="body2" color="textSecondary">
        This endpoint should be called when a user shares a clip to another
        platform.
      </Typography>

      <form onSubmit={handleSubmit}>
        <Box className="share-container">
          <TextField
            fullWidth
            label="Clip ID"
            variant="outlined"
            value={clipId}
            onChange={(e) => {
              setClipId(e.target.value);
            }}
            className="share-textfield"
            type="number"
            required
          />

          <Box className="share-info">
            <Typography variant="body2" color="textSecondary">
              Client ID: {clientId}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Timestamp: {timestamp}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Share URI (Destination of the share): {shareUri}
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={client.getToken() === ''}
            className="share-button"
          >
            Share Clip
          </Button>
        </Box>
      </form>

      {error && (
        <Alert severity="error" className="share-error">
          {error}
        </Alert>
      )}

      {response && (
        <Box className="share-response">
          <Typography variant="h6" gutterBottom>
            Response:
          </Typography>
          <Paper variant="outlined" className="share-response-paper">
            <pre className="share-response-pre">
              {JSON.stringify(response, null, 2)}
            </pre>
          </Paper>
        </Box>
      )}
    </Paper>
  );
};

export default Share;
